module.exports = __webpack_public_path__ + "static/media/integrator_logo.70c10b6d.png";